var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogin01 = function SvgLogin01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M11.552 14.263c.34.807.778 1.559 1.284 2.26l-9.755 9.756a1.096 1.096 0 0 0 .001 1.547 1.1 1.1 0 0 0 1.547 0l9.65-9.653a11.6 11.6 0 0 0 4.234 2.56v1.734a1 1 0 0 1-.998.998h-2.744v2.744a1 1 0 0 1-.997.998H11.03v2.744a1 1 0 0 1-.998.998H7.236l-.697.697c-.425.426-4.698.65-5.767-.417-1.07-1.07-.844-5.342-.418-5.77zM25.373 3.38a3.245 3.245 0 1 0 .002 6.49 3.245 3.245 0 0 0-.002-6.49M22.255 0C27.636 0 32 4.362 32 9.744s-4.364 9.745-9.745 9.745c-5.382 0-9.745-4.363-9.745-9.745S16.873 0 22.255 0"
  })));
};
export { SvgLogin01 as ReactComponent };
export default __webpack_public_path__ + "assets/Login-01.371f17db23bc80718dc40528adf58db5.svg";